import i18n from '@/i18n'
import useConfirmModal from '@/composables/useConfirmModal'

const DEFAULT_CONFIRM_PARAMS = {
    header: String(i18n.t('general.defaultConfirmation')),
    message: String(i18n.t('dialog.confirm.update.cancel')),
    type: 'confirm' as const
}

/**
 * Composable for modal close confirmation.
 */
export function useConfirmBeforeClose () {
    function closeWithConfirm (closeFn: () => void) {
        useConfirmModal(DEFAULT_CONFIRM_PARAMS).then((isConfirmed) => {
            if (isConfirmed) {
                closeFn()
            }
        })
    }

    return { closeWithConfirm }
}
